<template>
  <div class="auth-layout-form">
    <h4 class="auth-layout-title">ثبت نام در پلتفرم ابری تلاش‌نت</h4>
    <b-form @submit.prevent="onSubmit">
      <b-form-group>
        <b-form-input
          autocomplete="off"
          @update="usernameChangeHandler"
          :state="this.validUsername"
          type="text"
          v-model="form.username.value"
          placeholder="نام کاربری"
        ></b-form-input>
        <b-form-invalid-feedback class="text-right" :state="this.validUsername">
          {{ form.username.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-input
          autocomplete="off"
          @update="phoneChangeHandler"
          :state="this.validPhone"
          type="text"
          v-model="form.phone.value"
          placeholder="تلفن همراه"
        ></b-form-input>
        <b-form-invalid-feedback class="text-right" :state="this.validPhone">
          {{ form.phone.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-input
          @update="passwordChangeHandler"
          type="password"
          :state="this.validPassword"
          v-model="form.password.value"
          placeholder="رمز عبور"
        >
        </b-form-input>
        <b-form-invalid-feedback class="text-right" :state="this.validPassword">
          {{ form.password.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-input
          @update="confirmPasswordChangeHandler"
          :state="this.validConfirmPassword"
          type="password"
          v-model="form.confirmPassword.value"
          placeholder="تکرار رمز عبور"
        ></b-form-input>
        <b-form-invalid-feedback
          class="text-right"
          :state="this.validConfirmPassword"
        >
          {{ form.confirmPassword.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="form-checkbox">
        <b-form-checkbox
          v-model="form.policy.value"
          @change="policyChangeHandler"
          :state="this.validPolicy"
        >
          <router-link to="/policy">قوانین و مقررات</router-link>
          را می پذیرم
        </b-form-checkbox>
        <b-form-invalid-feedback class="text-right" :state="this.validPolicy">
          {{ form.policy.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <LoadingBtn
          block
          type="submit"
          variant="primary"
          :disabled="disabled || loader"
          :loading="loader"
        >
          ثبت نام
        </LoadingBtn>
      </b-form-group>
      <error-messages
        :show="showMessage"
        :messages="alertMessage"
        :dismissible="true"
        @dismissed="dismissedError"
      />
    </b-form>
    <div class="auth-layout-footer">
      <router-link to="/login">
        من قبلاً حساب کاربری داشتم
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { register } from "@/services/auth";
import {
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  SIGNUP_USER_SUCCESS
} from "@/store/mutation-types";
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";
export default {
  name: "FormRegister",
  components: {
    LoadingBtn,
    ErrorMessages
  },
  props: {
    form: Object
  },
  data() {
    return {
      validUsername: null,
      validPhone: null,
      validPassword: null,
      validConfirmPassword: null,
      validPolicy: null,
      disabled: true
    };
  },
  computed: {
    ...mapState("auth", ["alertMessage", "loader", "showMessage"])
  },
  methods: {
    ...mapActions("auth", [
      ON_SHOW_LOADER,
      SHOW_MESSAGE,
      HIDE_MESSAGE,
      SIGNUP_USER_SUCCESS
    ]),
    dismissedError: function() {
      this[HIDE_MESSAGE]();
    },
    goToResendSms: function() {
      this.$emit("next", true);
    },
    onSubmit: async function() {
      this[ON_SHOW_LOADER]();
      const [error, data] = await register({
        username: this.form.username.value,
        phoneNumber: this.form.phone.value,
        password: this.form.password.value
      });
      if (error) this[SHOW_MESSAGE](error);
      else {
        if (data.apiStatus === 200) {
          this[SIGNUP_USER_SUCCESS]();
          this.goToResendSms();
        } else {
          this[SHOW_MESSAGE](data.apiErrors);
        }
      }
    },
    usernameChangeHandler: function(val) {
      const reg = /^(?=[a-zA-Z0-9-]{4,25}$)(?!.*[-]{2})[^-].*[^-]$/;
      if (val === "") {
        this.form.username.error = "نام کاربری الزامی است.";
        this.validUsername = false;
      } else {
        if (!reg.test(val)) {
          this.form.username.error =
            "نام کاربری باید دارای 4 الی 25 کاراکتر طول؛ شامل حروف، اعداد و کاراکترهایی مانند (-) در وسط باشد.";
          this.validUsername = false;
        } else {
          this.form.username.error = "";
          this.validUsername = true;
        }
      }
    },
    phoneChangeHandler: function(val) {
      // const reg = /(0|\+98)?([ ]|,|-|[()]){0,2}9[1|2|3|4]([ ]|,|-|[()]){0,2}(?:[0-9]([ ]|,|-|[()]){0,2}){8}/;
      const reg = /^[0-9]*$/;
      if (val === "") {
        this.form.phone.error = "تلفن همراه الزامی است.";
        this.validPhone = false;
      } else {
        if (!reg.test(val)) {
          this.form.phone.error = "تلفن همراه باید عددی باشد.";
          this.validPhone = false;
        } else {
          if (val.length != 11) {
            this.form.phone.error = "تلفن همراه باید 11 رقمی باشد.";
            this.validPhone = false;
          } else {
            this.form.phone.error = "";
            this.validPhone = true;
          }
        }
      }
    },
    passwordChangeHandler: function(val) {
      const preg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&\-_])[A-Za-z\d@$!%*#?&]{8,}$/;
      if (val === "") {
        this.form.password.error = "رمز عبور الزامی است";
        this.validPassword = false;
      } else {
        if (!preg.test(val)) {
          this.form.password.error =
            "رمز عبور باید شامل حروف کوچک یا بزرگ انگلیسی، حداقل یک عدد، حداقل یک کاراکتر خاص و حداقل 8 کاراکتر باشد.";
          this.validPassword = false;
        } else {
          this.form.password.error = "";
          this.validPassword = true;
          if (this.form.password.value !== this.form.confirmPassword.value) {
            this.form.confirmPassword.error =
              "رمز عبور با تکرار رمز عبور مطابقت ندارد.";
            this.validConfirmPassword = false;
          } else {
            this.form.confirmPassword.error = "";
            this.validConfirmPassword = true;
          }
        }
      }
    },
    confirmPasswordChangeHandler: function(val) {
      if (val === "") {
        this.form.confirmPassword.error = "تکرار رمز عبور الزامی است";
        this.validConfirmPassword = false;
      } else {
        if (this.form.password.value !== this.form.confirmPassword.value) {
          this.form.confirmPassword.error =
            "رمز عبور با تکرار رمز عبور مطابقت ندارد.";
          this.validConfirmPassword = false;
        } else {
          this.form.confirmPassword.error = "";
          this.validConfirmPassword = true;
        }
      }
    },
    policyChangeHandler: function(val) {
      if (!val) {
        this.form.policy.error = "پذیرفتن قوانین الزامی است.";
        this.validPolicy = false;
      } else {
        this.form.policy.error = "";
        this.validPolicy = true;
      }
    }
  },
  updated() {
    if (
      this.validUsername &&
      this.validPhone &&
      this.validPassword &&
      this.validConfirmPassword &&
      this.validPolicy
    ) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }
};
</script>

<style scoped></style>
